"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Step = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classNames_1 = require("../../../utils/classNames");
const theme_1 = require("../../../utils/theme");
const Step = (props) => {
    const { label, selected } = props;
    const theme = (0, theme_1.useTheme)();
    const selectedClasses = theme.components.step.selected;
    const unSelectedClasses = theme.components.step.unselected;
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex", children: (0, jsx_runtime_1.jsx)("div", { className: (0, classNames_1.cn)(selected ? selectedClasses : unSelectedClasses), children: label }) }));
};
exports.Step = Step;
